import BridgeV2 from "@akulaku/web-bridge";
import Router from "@al/next/router";

// 通用返回方法
const goBack = (): void => {
  // 宿主app
  if (BridgeV2.isAkulaku()) {
    BridgeV2.backackByStep({ count: 1 });
  } else {
    Router.back();
  }
};

export default goBack;
